import { TicketList } from './TicketList';
import { TicketShow } from './TicketShow';
import { Ticket } from '@/types';

export default {
    list: TicketList,
    show: TicketShow,
    recordRepresentation: (record: Ticket) =>
        record?.content
            ? `Ticket #${record.id}`
            : `Ticket #${record?.id ?? ''}`,
};
